// extracted by mini-css-extract-plugin
export var infoRow = "_sa-2";
export var labelContainer = "_sa-0";
export var rightInfo = "_sa-1";